var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.ssr
        ? _vm._t("body")
        : [
            _c("h1", { staticClass: "estates-list-title" }, [
              _vm._v("\n            " + _vm._s(_vm.title) + "\n        ")
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }